import { useIntl, defineMessages } from 'react-intl'
import { formatCurrency } from '../../../../../../helpers/formatters'
import { Box, Flex, Text, Heading, Card } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  propertyTaxes: {
    id: 'EstimatedMonthlyPaymentBreakdown.propertyTaxes',
    defaultMessage: 'Property taxes'
  },
  propertyTaxesDescription: {
    id: 'EstimatedMonthlyPaymentBreakdown.propertyTaxesDescription',
    defaultMessage: 'Based on historical data'
  }
})

export interface EstimatedMonthlyPaymentBreakdownPropertyTaxesProps {
  propertyTaxes: number
}

export const EstimatedMonthlyPaymentBreakdownPropertyTaxes = ({
  propertyTaxes
}: EstimatedMonthlyPaymentBreakdownPropertyTaxesProps) => {
  const intl = useIntl()

  return (
    <Card p={3}>
      <Flex justify='space-between' align='center'>
        <Flex gap={2} align='center'>
          {/* @TODO:DESIGNSYSTEM - add purple ramp */}
          {/* @ts-ignore */}
          <Box bg='#9770F7' width={3} height={3} borderRadius='50%' />
          <Heading as='h4' size={['2xs', 'xs', 'sm']}>
            {intl.formatMessage(MSG.propertyTaxes)}
          </Heading>
        </Flex>
        <Text
          mb={0}
          color='neutral.900'
          size={['xs', 'sm', 'md']}
          fontWeight='semibold'
          style={{ fontVariant: 'tabular-nums' }}
        >
          {formatCurrency(propertyTaxes)}
        </Text>
      </Flex>
      <Text ml={5} as='span' size={['2xs', 'xs', 'sm']} display='block'>
        {intl.formatMessage(MSG.propertyTaxesDescription)}
      </Text>
    </Card>
  )
}
